module.exports = {
    home: {
        home: 'Home',
        node: 'NODE',
        docs: 'DOCS',
        FUND: 'FUND',
        VAULTDIVIDEND: 'VAULT DIVIDEND',
        VAULT: 'VAULT',
        launchDapp: "LAUNCH DAPP",
        welcomeFireCat:'Welcome to the FireCat Finance',
        evolvingEcosystem:'The FirecatFinance is an evolving ecosystem of innovations, including an NFT farming platform with high APR DeFi features, Vault Products, Decentralized Exchange, and much much more product and serve.',
        whatFireCat:'What is FireCat Finance？',
        nextNft:'Next gen NFT',
        multiBlockchain:'Multi-Blockchain use',
        endlessPossibilites:'Endless possibilites',
        vaults:'Vaults',
        bestStrategies:'Best-in-class strategies',
        highAPR:'High APR',
        highLiquidity:'High liquidity',
        nextDEFImining:'Next gen DEFI mining',
        combination:'Combination of DEFI and NFT',
        continualReward:'Stable & continual Reward',
        dex:'DEX',
        swapAnything:'Swap anything',
        earnTradingFees:'Earn trading fees',
        noRegistration:'No registration',
        communityGovernance:'Community governance',
        proposal:'Proposal',
        voting:'Voting',
        earnReward:'Earn reward through recommended user seaked in FireCar Finance',
        roadmap:'Roadmap',
        phase:'Phase',
        websiteLaunch:'Website Launch',
        smartContractDeployment:'Smart Contract Deployment',
        fairTokenLaunch:'100% Fair Token Launch',
        airdropEvent:'Airdrop event',
        whitepaperRelease:'Whitepaper Release',
        nftOnline:'NFT online',
        firecatNFTonline:'Firecat NFT online',
        vaultsProtocolOnline:'Vaults protocol online',
        nftLevelUpOnline:'NFT level up online',
        moreNFTonline:'More NFT online',
        decentralizedDAOVotingSystem:'Decentralized DAO Voting System',
        decentralizedExchange:'Decentralized Exchange',
        moreVaults:'More Vaults',
        supportMoreBlockChain:'Support more Block chain',
        commingSoon: 'Comming Soon',
        back: 'Back',
        register: 'Register',
        referrerAddress: 'Referrer Address',
        connectWallet: 'Connect Wallet',
        pleaseEnter: 'Please enter....',
        neterror: 'Neterror',
        confirm: 'Confirm',
        registrationSucceeded:'Registration Succeeded',
        pleaseRevise:'Your referrer address is wrong. Please revise and submit',
        loading: 'Loading',
        registered: 'Registered',
        myReferrals: 'My referrals',
        viewSubordinates: 'View Subordinates',
        myAddress: 'My address',
        numberOfSubordinates: 'Number of subordinates',
    }

  }